interface IUseGetSearchParams {
    query: string;
}

export const getQueryValue = ({ query }: IUseGetSearchParams) =>
    new URLSearchParams(window.location.search).get(query);
